import { defaultConfig, defineTokens } from '@chakra-ui/react';

const animations = defineTokens.animations({
    ...defaultConfig.theme?.tokens?.animations,
    scroll: { value: 'scroll 30s linear infinite' },
    flashSuccess: { value: 'flashSuccess 2s ease-out' },
    flashDanger: { value: 'flashDanger 2s ease-out' },
});

export { animations };
